import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  FirstPage as FirstPageIcon,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  LastPage as LastPageIcon,
} from "@mui/icons-material";

const ServerTablePaginationActions = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
}) => {
  const theme = useTheme();
  const safeRowsPerPage = rowsPerPage > 0 ? rowsPerPage : 1;
  const totalPages = Math.max(1, Math.ceil((count || 0) / safeRowsPerPage));
  const lastPage = totalPages - 1;
  const currentPage = Math.min(Math.max(page, 0), lastPage);

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, currentPage - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, currentPage + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, lastPage);
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5, display: "flex", alignItems: "center" }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={currentPage === 0}
        aria-label="Go to first page"
        size="small"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={currentPage === 0}
        aria-label="Go to previous page"
        size="small"
      >
        {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <Typography
        variant="body2"
        sx={{ minWidth: 92, textAlign: "center", fontWeight: 600, mx: 1 }}
      >
        Page {currentPage + 1} of {totalPages}
      </Typography>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={currentPage >= lastPage}
        aria-label="Go to next page"
        size="small"
      >
        {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={currentPage >= lastPage}
        aria-label="Go to last page"
        size="small"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
};

export default ServerTablePaginationActions;
